import styled from 'styled-components';

const Section = styled.section`
  width: 100%;
  padding-bottom: 4rem;
`;

export default Section;
